import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ContentService} from "../../_services/content.service";
import {AuthService} from "../../_services/auth.service";
import {SnackbarService} from "../../_services/snackbar.service";
import {User} from "../../_types/user";
import {TimelinePermission} from "../../_types/memorybox";

export interface ManageAccessDialogData {
    context: string,
    id: number,
    userId: number
}

@Component({
    selector: 'app-manage-access',
    templateUrl: './manage-access.component.html',
    styleUrl: './manage-access.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ManageAccessComponent {
    permissions: TimelinePermission[] | null = null;
    id: number | undefined;
    userId: number | undefined;
    user!: User;
    title: string = "Manage Access"

    constructor(@Inject(MAT_DIALOG_DATA) private data: ManageAccessDialogData,
                protected dialogRef: MatDialogRef<ManageAccessComponent>,
                public dialog: MatDialog,
                private contentService: ContentService,
                private snackbarService: SnackbarService,
                private authService: AuthService) {
        this.authService.getUser().subscribe({
            next: r => {
                this.user = r;
            }
        })

        if (data.context) {
            this.title = 'Manage ' + data.context + ' Access';
        }
        if (data.userId) {
            this.userId = data.userId;
        }

        if (data.id) {
            this.id = data.id;
            this.contentService.viewTimelinePermissions(this.data.id).subscribe({
                next: r => {
                    this.permissions = r;
                }, error: error => {
                    this.snackbarService.openSnackBar(error, 'error')
                    console.error(error)
                }
            });
        }
    }
}
